import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--announcements--form"
export default class extends Controller {
  static targets = ["form", "title", "tagName", "tagTextColor", "tagTextColorPreview"];

  connect() {
    this.updateBreadcrumbUsername();
    this.onTagChange()
  }

  updateBreadcrumbUsername() {
    const breadcrumbUsername = document.getElementById("announcement-title");
    breadcrumbUsername.textContent = this.titleTarget.value ?? "―";
  }

  onTagChange() {
    const tagName = this.tagNameTarget.value;
    const tagTextColor = this.tagTextColorTarget.value;
    const tagTextColorPreview = this.tagTextColorPreviewTarget;

    if (tagName && tagTextColor) {
      tagTextColorPreview.style.color = tagTextColor;
      tagTextColorPreview.style.display = "inline-block";
      tagTextColorPreview.innerHTML = tagName;
    } else {
      tagTextColorPreview.style.display = "none";
    }
  }
}
